import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchDocumentFile } from '../api/documents';
import { useCallback } from 'react';

function documentFileQueryKey(
  fileId: string | null,
  includeUnavailable: boolean
) {
  return ['documentFile', fileId, { includeUnavailable }] as const;
}

export function useDocumentFile(
  fileId: string | null,
  includeUnavailable = false
) {
  return useQuery({
    queryKey: documentFileQueryKey(fileId, includeUnavailable),
    queryFn: () => fetchDocumentFile(fileId!, { includeUnavailable }),
    enabled: Boolean(fileId),
    staleTime: Infinity,
  });
}

export const useInvalidateDocumentFile = () => {
  const queryClient = useQueryClient();

  return useCallback((fileId: string | null, includeUnavailable = false) => {
    queryClient.invalidateQueries({
      queryKey: documentFileQueryKey(fileId, includeUnavailable)
    });
  }, [queryClient]);
};

export const useInvalidateDocumentFileAll = () => {
  const invalidateFileQueryBase = useInvalidateDocumentFile();

  return useCallback((fileId: string | null) => {
    invalidateFileQueryBase(fileId, false);
    invalidateFileQueryBase(fileId, true);
  }, [invalidateFileQueryBase]);
};
